module.exports = require("./hu.d.ts");